import React, { useState } from "react";
import { Navbar, Container, NavbarBrand } from "reactstrap";
import routes from "routes.js";

const Header = (props) => {
  const [state] = useState({
    isOpen: true,
    dropdownOpen: true,
    color: "transparent",
  });

  const sidebarToggle = React.createRef();

  const getBrand = () => {
    let brandName = "";
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    window.dispatchEvent(new CustomEvent("toggleNav"));
  };

  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color={
        props.location.pathname.indexOf("full-screen-maps") !== -1
          ? "dark"
          : state.color
      }
      //expand="lg"
      className={"bg-black"}
    >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => openSidebar()}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <NavbarBrand href="/">{getBrand()}</NavbarBrand>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
